import { render, staticRenderFns } from "./TextBlockInner.vue?vue&type=template&id=0b2a9665&"
import script from "./TextBlockInner.vue?vue&type=script&lang=js&"
export * from "./TextBlockInner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports